export class Stock{
    public stock:number
    public agencyId:string

    constructor(data:any){
        this.stock = data.stock
        this.agencyId = data.agencyId
    }
}